<ion-item lines="none" class="ion-no-padding" [style.max-width]="maxWidth">
  <ion-checkbox [id]="id" [disabled]="disabled" slot="start" [(ngModel)]="value"></ion-checkbox>
  <ion-label class="ion-text-wrap">
    {{ hideLabel ? '' : label }}
    <p>{{subLabel}}</p>
  </ion-label>
</ion-item>